import { omit } from 'lodash';

export enum PayoutDisputeStatusDetails {
  DisputePaymentTimeout = 'payment_timeout',
  DisputeInvalidRequisites = 'invalid_requisites',
  DisputePaymentFailed = 'payment_failed',
  DisputeRevertCancelled = 'revert_cancelled',
  DisputeVerify = 'dispute_verify',
  DisputeAdminCreated = 'admin_created',
  DisputeCascadeAssigneeTimeout = 'cascade_assignee_timeout',
  DisputeCascadeTotalTimeout = 'cascade_total_timeout',
  DisputeUnresolvedResponse = 'unresolved_response',
  DisputeProviderCancelUnconfirmed = 'provider_cancel_unconfirmed',
}

export enum PayoutRejectStatusDetails {
  RejectNoFunds = 'no_funds',
  RejectRequisitesBlocked = 'requisites_blocked',
  RejectPaymentImpossible = 'payment_impossible',
}

export enum PayoutCancelStatusDetails {
  CancelledByShop = 'shop',
  CancelledByProvider = 'provider',
  CancelledPaymentTimeout = 'payment_timeout',
  CancelledByAdmin = 'admin',
  CancelledRequisitesTimeout = 'requisites_timeout',
  CancelledMaxRejectsExceeded = 'max_rejects_exceeded',
  CancelledByOperator = 'operator',
  CancelledManualTimeout = 'manual_timeout',
  CancelledCascadeExhausted = 'cascade_exhausted',
}

/**
 * Sub-states of a payout order parked in `new` for manual distribution:
 * ManualPending — waiting for an operator, ManualFailed — a previous send failed, retryable.
 */
export enum PayoutManualStatusDetails {
  ManualPending = 'manual_pending',
  ManualFailed = 'manual_failed',
}

export enum PayoutCompleteStatusDetails {
  CompletedHold = 'hold',
}

export const PayoutOrderStatusDetails = {
  ...PayoutDisputeStatusDetails,
  ...omit(PayoutCancelStatusDetails, [
    'CancelledPaymentTimeout',
    'CancelledCascadeExhausted',
  ]),
  ...PayoutRejectStatusDetails,
  ...PayoutCompleteStatusDetails,
  ...PayoutManualStatusDetails,
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type PayoutOrderStatusDetails =
  | PayoutDisputeStatusDetails
  | PayoutCancelStatusDetails
  | PayoutRejectStatusDetails
  | PayoutCompleteStatusDetails
  | PayoutManualStatusDetails;
